<script>
export default {
  props: [ 'modalWinsDetailTableRows', 'weekToReview' ],
}
</script>

<template>
  <v-table v-if="modalWinsDetailTableRows.length" density="compact" class="border">
    <thead>
    <tr class="bg-grey-lighten-3">
      <th class="text-center font-weight-medium" style="min-width: 245px; width: 350px;">Win</th>
      <th
          v-for="day in weekToReview"
          :key="day.value"
          class="text-center border"
      >
        {{ day.weekday }}<br>
        <small class="text-grey">{{ day.month }}<br />{{ day.day }}</small>
      </th>
    </tr>
    </thead>
    <tbody>
    <tr v-for="row in modalWinsDetailTableRows" :key="row.programId">
      <td class="py-2 pe-0" style="min-width: 245px; width: 350px;">
        <small class="text-grey me-2">{{ row.order }})</small>
        {{ row.winText }}
      </td>
      <td
          v-for="day in weekToReview"
          :key="day.value"
          class="text-center border py-2"
      >
        <v-icon
            :color="row.cells[day.value].stacked ? 'success' : 'error'"
            size="24"
        >
          {{ row.cells[day.value].stacked ? 'mdi-check-circle' : 'mdi-close-circle' }}
        </v-icon>
      </td>
    </tr>
    </tbody>
  </v-table>
</template>

<style scoped lang="scss">

</style>
